import { testimonioData } from './mock/testimoniosMock.js';

angular.module('Toke').factory('testimoniosRepository', function ($q) {

    function getTestimonios() {
        return $q.resolve(testimonioData);
    }


    // para lista futura
    // function getTestimoniosFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Unete')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }

    return {
        getTestimonios: getTestimonios
    };

});
